export const ENABLED_CARD_SELECTOR = 'button[role="radio"]:not(:disabled)';
